/* global axios */

const state = {
  subscription: null,
  hasFetched: false, // true após o primeiro fetchSubscription completar (sucesso ou erro)
  isBlocked: false,
  blockedReason: '',
  gracePeriodEnd: null,
  isFetching: false,
};

const getters = {
  isBlocked: $state => $state.isBlocked,
  blockedReason: $state => $state.blockedReason,
  gracePeriodEnd: $state => $state.gracePeriodEnd,
  subscription: $state => $state.subscription,
  isFetching: $state => $state.isFetching,
  hasFetched: $state => $state.hasFetched,
  planSlug: $state => $state.subscription?.plan || null,

  // Array de features habilitadas no plano. null = sem assinatura (tudo liberado).
  planFeatures: $state => {
    if (!$state.subscription) return null;
    return $state.subscription.features || [];
  },

  // Verifica se uma feature de módulo está habilitada no plano.
  // Sem assinatura = tudo liberado (contas internas/dev).
  hasFeature: $state => slug => {
    if (!$state.subscription) return true;
    const features = $state.subscription.features || [];
    return features.includes('*') || features.includes(slug);
  },

  // Retorna os limites do plano (null = ilimitado).
  planLimits: $state => $state.subscription?.limits || {},
};

const mutations = {
  SET_SUBSCRIPTION($state, subscription) {
    $state.subscription = subscription;
  },
  SET_FETCHED($state) {
    $state.hasFetched = true;
  },
  SET_BLOCKED($state, { blocked, reason, gracePeriodEnd }) {
    $state.isBlocked = blocked;
    $state.blockedReason = reason || '';
    $state.gracePeriodEnd = gracePeriodEnd || null;
  },
  SET_FETCHING($state, value) {
    $state.isFetching = value;
  },
};

const actions = {
  async fetchSubscription({ commit, rootGetters }, payload = {}) {
    // Aceita accountId explícito (vindo do guard de rota, antes do vuex-router-sync atualizar)
    // ou lê do getter normal (quando chamado pelo App.vue mounted)
    const accountId = payload.accountId || rootGetters.getCurrentAccountId;
    if (!accountId) return;
    commit('SET_FETCHING', true);
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId}/subscription`
      );
      // data é null quando não há assinatura (acesso total), ou o objeto plano
      commit('SET_SUBSCRIPTION', data || null);
      commit('SET_BLOCKED', {
        blocked: false,
        reason: '',
        gracePeriodEnd: null,
      });
    } catch (error) {
      if (error?.response?.status === 403 && error?.response?.data?.blocked) {
        const { reason, grace_period_end: gracePeriodEnd } =
          error.response.data;
        commit('SET_BLOCKED', { blocked: true, reason, gracePeriodEnd });
      }
    } finally {
      commit('SET_FETCHING', false);
      commit('SET_FETCHED'); // marca como carregado independente de sucesso/erro
    }
  },

  setBlocked({ commit }, payload) {
    commit('SET_BLOCKED', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
